//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Paper } from '@mui/material'
import { useOtChainState } from '@react/redux/store'
import ReportDateRangeSelector from '@react/reporting/ReportDateRangePicker'
import { REPORT_FETCH_DESCRIPTOR_TRANSACTION_LIST } from '@react/reporting/ReportDescriptors'
import { ReportExplorer } from '@react/reporting/ReportExplorer'
import { ReportRowGeneratorClass } from '@react/reporting/ReportRowGeneratorClass'
import dayjs, { Dayjs } from 'dayjs'
import { ZeroAddress } from 'ethers'
import React, { ReactElement, useEffect, useState } from 'react'

export default function LenderTransactionPage(): ReactElement {
  const [, forceRerender] = useState({})
  const {
    chainConfiguration: { providerReadOnly, chainTimestampDelta },
    stageConfiguration: { serverApiBaseUrl, restAPIKey },
    userConnection: { accountAddr },
  } = useOtChainState()
  const [reportRowGeneratorClass, setReportRowGeneratorClass] = useState<ReportRowGeneratorClass | undefined>(undefined)

  const [dateRange, setDateRange] = useState<[Dayjs, Dayjs]>([
    dayjs().utc().subtract(30, 'day').add(chainTimestampDelta, 'seconds').startOf('day'),
    dayjs().add(chainTimestampDelta, 'seconds').utc(),
  ])

  useEffect(() => {
    if (accountAddr && providerReadOnly) {
      const _reportRowGeneratorClass = new ReportRowGeneratorClass({
        reportDescriptor: REPORT_FETCH_DESCRIPTOR_TRANSACTION_LIST,
        providerReadOnly,
        serverApiBaseUrl,
        restAPIKey,
        poolAddr: ZeroAddress,
        lenderAddr: accountAddr,
        dateRange,
      })
      setReportRowGeneratorClass(_reportRowGeneratorClass)
      _reportRowGeneratorClass.refreshData().then(() => {
        forceRerender({})
      })
    }
  }, [accountAddr])
  return (
    <React.Fragment>
      <Paper sx={{ padding: 4, margin: 2 }}>
        <ReportDateRangeSelector
          selectedPoolAddrs={[]}
          onSelectedChange={(_dayRange: [Dayjs, Dayjs]) => {
            setDateRange(_dayRange)
            reportRowGeneratorClass?.refreshData().then(() => {
              forceRerender({})
            })
          }}
          forEvents={true}
          initialDateRange={dateRange}
        />
        {reportRowGeneratorClass && <ReportExplorer reportRowGeneratorClass={reportRowGeneratorClass} />}
      </Paper>
    </React.Fragment>
  )
}
